import {
  withResponsiveOptions,
  withBreakpointObserver,
  getClosestParent,
} from '@studiometa/js-toolkit';
import { Menu as MenuCore } from '@studiometa/ui';
import MenuList from './MenuList.js';
import MenuPush from './MenuPush.js';

/**
 * Menu class.
 */
export default class Menu extends withResponsiveOptions(withBreakpointObserver(MenuCore), {
  responsiveOptions: ['mode'],
}) {
  static config = {
    ...MenuCore.config,
    emits: ['open', 'close'],
    components: {
      ...MenuCore.config.components,
      MenuList,
      MenuPush,
      Menu,
    },
  };

  /**
   * isOpen
   * @returns {boolean}
   */
  get isOpen() {
    return this.$isMounted ? (this.menuList?.isOpen ?? false) : false;
  }

  /**
   * Emit open event.
   * @param {{ target: MenuList }} props
   */
  onMenuListItemsOpen(props) {
    if (getClosestParent(props.target, this.constructor) === this) {
      this.$emit('open');
    }

    super.onMenuListItemsOpen(props);
  }

  /**
   * Emit close event.
   * @param {{ target: MenuList }} props
   */
  onMenuListItemsClose(props) {
    if (getClosestParent(props.target, this.constructor) === this) {
      this.$emit('close');
    }
  }
}
